import { Box, Button } from '@mui/material'
import { Fragment } from 'react'
import SendIcon from '../../assets/send.svg'
import styles from './ExperimentFormFooter.module.css'

type ExperimentFormFooterProps = {
  activeStep: number
  onChangeStep: (step: number) => void
  onSubmitExperiment: () => void
  isSubmitDisabled: boolean
  isSubmitHidden: boolean
}

export const ExperimentFormFooter = ({
  activeStep,
  onChangeStep,
  onSubmitExperiment,
  isSubmitDisabled,
  isSubmitHidden,
}: ExperimentFormFooterProps) => {
  return (
    <Fragment>
      <Box className={styles.footer}>
        <div className={styles.navigation}>
          <Button
            onClick={() => onChangeStep(activeStep - 1)}
            disabled={activeStep <= 0}>
            Previous
          </Button>
          <Button
            onClick={() => onChangeStep(activeStep + 1)}
            disabled={activeStep >= 2}>
            Next
          </Button>
        </div>
        {!isSubmitHidden && (
          <Button
            onClick={onSubmitExperiment}
            variant="contained"
            disableElevation
            className={styles.submit}
            size="large"
            disabled={isSubmitDisabled}>
            <img src={SendIcon} />
            Submit Experiment
          </Button>
        )}
      </Box>
    </Fragment>
  )
}
